import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "0,8 10,8 5,0", fill: "currentColor" }));
export default SvgTriangle;
